import { render, staticRenderFns } from "./RelatorioGestaoPcaOrgaoFuncao.vue?vue&type=template&id=fae5aa14"
import script from "./RelatorioGestaoPcaOrgaoFuncao.vue?vue&type=script&lang=ts"
export * from "./RelatorioGestaoPcaOrgaoFuncao.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports